import React from 'react'
import css from './UserCardLink.module.css'

const UserCardLink = ({ children, icon, target = '_blank', ...props }) => {
  return (
    <a target={target} className={css.wrapper} {...props}>
      <div className={css.icon}>
        {icon}
      </div>
      <span className={css.value}>{children}</span>
    </a>
  )
}

export default UserCardLink



// WEBPACK FOOTER //
// ./components/Customers/presentational/UserCardLink.js